export enum ClaimConfirmationTestIds {
  CLAIM_BTN = 'claim_confirmation_claim',
}
